import type { TourResolver } from '@nucleus-commerce/admin-kit/tour';
import {
  getAdminV1OrgProducts,
  getAdminV1StoresStoreIdOrders,
} from '@nucleus-commerce/api-client/admin';

/** The product someone touched last: the editor tours run on it. */
export const newestProduct: TourResolver = {
  key: 'newest-product',
  thing: 'things.product',
  load: async () => {
    const page = await getAdminV1OrgProducts({ limit: 1, sort: '-updatedAt' });
    const product = page.items[0];
    return product ? { productId: product.id } : null;
  },
};

/** An open paid order shows the most of the page (production card included); else the newest. */
export const orderForDetail: TourResolver = {
  key: 'order-for-detail',
  thing: 'things.order',
  load: async ({ storeId }) => {
    if (!storeId) return null;
    const paid = await getAdminV1StoresStoreIdOrders(
      { storeId },
      { limit: 1, status: 'open', financialStatus: 'paid' },
    );
    const order =
      paid.items[0] ?? (await getAdminV1StoresStoreIdOrders({ storeId }, { limit: 1 })).items[0];
    return order ? { storeId, orderId: order.id } : null;
  },
};

/** The production card tours need an order whose workflow is running. */
export const orderInProduction: TourResolver = {
  key: 'order-in-production',
  thing: 'things.orderInProduction',
  load: async ({ storeId }) => {
    if (!storeId) return null;
    const page = await getAdminV1StoresStoreIdOrders(
      { storeId },
      { limit: 25, financialStatus: 'paid' },
    );
    const order = page.items.find((item) => item.workflow?.status === 'active');
    return order ? { storeId, orderId: order.id } : null;
  },
};
